import { createContext, useContext } from "react";
import { IKeyboardNavigationApi } from "../types/keyboard-navigation";
import { IL10nApi } from "../types/l10n";

export const NavigationContext = createContext<IKeyboardNavigationApi | null>(null);

export const useNavigationContext = (): IKeyboardNavigationApi => {
    const ctx = useContext(NavigationContext);
    if (!ctx) {
        console.error("useNavigationContext must be used within NavigationContext.Provider");
        throw new Error("useNavigationContext must be used inside NavigationContext.Provider");
    }
    return ctx;
};

export const L10nContext = createContext<IL10nApi | null>(null);

export const useL10nContext = (): IL10nApi => {
    const ctx = useContext(L10nContext);
    if (!ctx) {
        console.error("useL10nContext must be used inside L10nContext.Provider");
        throw new Error("useL10nContext must be used inside L10nContext.Provider");
    }
    return ctx;
};
